import React, { type FC, type ReactElement } from 'react';

import { type PointageResult as TPointageResult, pointageResultLabel } from '~/types/models';

const PointageResult: FC<{
  value: TPointageResult;
}> = function ({ value }): ReactElement {
  return <span>{pointageResultLabel[value]}</span>;
};

export default PointageResult;
